export enum FeatureKey {
  BUNDLE_FLOW_ENABLED = 'bundleFlowEnabled',
  NBN_MOVERS_ENABLED = 'nbnMoversEnabled',
  NBN_MOVERS_CROSS_SELL_ENABLED = 'nbnMoversCrossSellEnabled',
  NBN_COMMON_LINKS_ENABLED = 'nbnCommonLinksEnabled'
}
